export type IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: 'UNION';
        name: 'BrandAssetBundle';
        possibleTypes: [
          {
            name: 'BrandAssetBundleVenmo';
          },
          {
            name: 'BrandAssetBundleDefaultBranding';
          },
        ];
      },
    ];
  };
};
const result: IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: 'UNION',
        name: 'BrandAssetBundle',
        possibleTypes: [
          {
            name: 'BrandAssetBundleVenmo',
          },
          {
            name: 'BrandAssetBundleDefaultBranding',
          },
        ],
      },
    ],
  },
};
export default result;
